<script>
  import ApplicationState from "../../../../Stores/applicationStates"
  import { onMount } from "svelte"
  import notify from "../../../../Script/notify"
  import Navbar from "../../../../Shared/Navbar/index.svelte"
  import Footer from "../../../../Shared/footer.svelte"
  import Loader from "../../../../Shared/Slots/loader.svelte"
  import Item from "./Components/item.svelte"
  // import DocumentCarousel, { DocObj, updateDocStores } from "./Stores/documentTemplate"
  import Table from "../../../../Shared/Table/table.svelte"
  import Filter from "../../../../Shared/filter.svelte"
  import { querystring, push } from "svelte-spa-router"
  import { queryStringToJSON } from "../../../../Script/queryString"
  import { getRequest } from "../../../../Script/apiMethods"
  let query

  let limit
  let page
  let sort
  let sortBy
  let search = {
    searchParam: "name",
    searchvalue: "",
  }
  let startDate = null
  let endDate = null

  let showLoading = false

  /**
   * @type {Boolean} - to show loading screen during templates loading from server
   */
  let loadingScreen = true

  /**
   * @type {String} text displayed with the svg loader while loading
   */
  let loadingText = "Fetching List of Document Templates&nbsp;"

  let docList = []

  let count

  onMount(async () => {
    try {
      loadingScreen = true

      query = queryStringToJSON($querystring)
      limit = query.limit ? query.limit : 10
      page = query.page ? query.page : 1
      sort = query.sort ? query.sort : -1
      sortBy = query.sortBy ? query.sortBy : "date"
      if (query.sdate) startDate = query.sdate
      if (query.edate) endDate = query.edate
      if (query.sname) search.searchvalue = query.sname
      // if (query.sin) search.searchParam ? query.sin : "name"

      await fetchDocumentTemplates()
    } catch (error) {
      const info = "PAGE: Document template list\nEVENT: onMount"
      notify.danger(error, info)
    } finally {
      // Regardless of success or failure, set loadingScreen to false
      loadingScreen = false
    }
  })

  const whileChangingEntries = async (e) => {
    try {
      if (e.detail.entries) limit = e.detail.entries
      if (e.detail.activePage) page = e.detail.activePage
      if (e.detail.sort) sort = e.detail.sort
      if (e.detail.sortBy) sortBy = e.detail.sortBy
      // if (e.detail.filter.date.endDate || e.detail.filter.date.startDate) {
      startDate = e.detail.filter.date.startDate ? e.detail.filter.date.startDate : ""
      endDate = e.detail.filter.date.endDate ? e.detail.filter.date.endDate : ""
      // }
      if (e.detail.filter.search.searchParam) {
        search.searchParam = e.detail.filter.search.searchParam
        search.searchvalue = e.detail.filter.search.searchvalue
      }
      await fetchDocumentTemplates()
    } catch (error) {
      const info = "PAGE: Document template list\nEVENT: Error occurred during actions such as sorting by date/ name, changing display entries, changing date filter, searching by name, or navigating pages."
      notify.danger(error, info)
    }
  }

  const resetList = async () => {
    try {
      limit = 10
      page = 1
      sort = 1
      sortBy = "date"
      search.searchvalue = ""
      startDate = null
      endDate = null
      await fetchDocumentTemplates()
    } catch (error) {
      const info = "PAGE: Document template list\nEVENT: Error occurred while resetting filter."
      notify.danger(error, info)
    }
  }

  /**
   * updating existing list when component mounted initially
   */
  const fetchDocumentTemplates = async () => {
    try {
      loadingScreen = true

      // Fetch data from three different endpoints concurrently
      const data = await getRequest(`/api/swagger/v2/templates/documents?limit=${limit}&page=${page}&sort=${sort}&sortBy=${sortBy}${search.searchvalue ? `&sin=${search.searchParam}&sname=${search.searchvalue}` : ``}${startDate ? `&sdate=${startDate}` : ``}${endDate ? `&edate=${endDate}` : ``}`, {
        headers: {
          "x-access-token": $ApplicationState.token,
        },
      })

      push(`/templates/document?limit=${limit}&page=${page}&sort=${sort}&sortBy=${sortBy}${search.searchvalue ? `&sin=${search.searchParam}&sname=${search.searchvalue}` : ``}${startDate ? `&sdate=${startDate}` : ``}${endDate ? `&edate=${endDate}` : ``}`)

      count = data.count
      docList = data.templates
    } catch (error) {
      throw error
    } finally {
      loadingScreen = false
    }
  }
</script>

<svelte:head>
  <title>Document Templates</title>
</svelte:head>

<!-- <DeleteTemplateModal /> -->
{#if loadingScreen}
  <Loader>
    <span class="flex">
      {@html loadingText}
    </span>
  </Loader>
{/if}
<div class="relative min-h-screen w-full overflow-auto overflow-x-hidden bg-[#f7f7f7] pb-24 dark:bg-bodyblack">
  <Navbar />
  <div class="px-6 pb-12 pt-3">
    <div class="relative mx-auto mt-8 h-full w-full max-w-[920px] rounded-md bg-[#f7f7f7] dark:bg-bodyblack">
      <!-- svelte-ignore a11y-click-events-have-key-events -->
      <button
        type="button"
        on:click={() => {
          push("/templates/document/edit?id=000000000000000000000000")
        }}
        disabled={showLoading}
        class="absolute right-0 top-0 z-10 flex h-9 w-max min-w-[36px] cursor-pointer select-none items-center justify-center rounded-md border border-transparent bg-blue-500 px-2 text-sm font-medium text-white hover:bg-blue-600 focus:outline-none active:bg-blue-500 disabled:cursor-not-allowed disabled:bg-blue-200"
      >
        <span>
          <i class="fa-solid fa-plus" />
        </span>
        <span class="hidden sm:block">&nbsp;Add Document Template</span>
        <span class="block sm:hidden">&nbsp;Add</span>
      </button>
      <Table on:changeEntries={whileChangingEntries} on:resetEntries={resetList} title="Document Templates" filterComponent={Filter} filter={true} jsonData={docList ? docList : []} {count}>
        <!-- List component -->

        {#if docList.length}
          {#each docList as Json}
            <Item
              {count}
              template={Json}
              bind:loadingScreen
              bind:loadingText
              on:fetchList={async () => {
                try {
                  await fetchDocumentTemplates()
                } catch (error) {
                  const info = "PAGE: Document template list\nEVENT: Error occurred while fetching document template list again after deletion/ duplication of document template."
                  notify.danger(error, info)
                }
              }}
            />
          {/each}
        {:else}
          <div class="select-none rounded-md bg-white py-6 text-center text-2xl dark:bg-darkgray dark:text-white">There is no document template</div>
        {/if}
      </Table>
    </div>
  </div>

  <Footer />
</div>
